module.exports = __webpack_public_path__ + "static/media/covid-19_Kenya_June_2021.2170dff5.pdf";